<!--suppress ALL -->
<script lang="ts">
  import {Component, Prop, Extend, Vue} from 'annotation';
  import {cloneDeep, isNil} from 'lodash';
  import {Bar, mixins} from 'vue-chartjs';
  import {ChartColors} from '@/config/ChartTheme';

  @Component({mixins: [mixins.reactiveProp]})
  export default class BarChart extends Vue {

    @Extend
    public extend() {
      return Bar
    }

    @Prop({default: []})
    public labels: Array<string>;

    @Prop({required: true})
    public datas: Array<any>;

    @Prop({default: {}})
    public options: Object;

    @Prop({type: Boolean, default: false})
    public skipDefaultTooltip: boolean;

    public afterCreated: boolean = false;

    public get properties() {
      return [this.datas, this.labels];
    }

    public mounted() {
      this.afterCreated = true;
      this.createChart();
    }

    public get datasets() {
      const {datas} = this;

      return cloneDeep(datas).map((item: any) => {
        // automaticaly sets bgColor if there is no bg color
        if (isNil(item.backgroundColor)) {
          item.backgroundColor = ChartColors.info;
        }

        return item;
      });
    }

    public get chartData() {
      const {labels, datasets} = this;

      return {labels, datasets};
    }

    public createChart() {
      const {chartData, options} = this;
      const tooltipOptions: any = {
        tooltips: {
          callbacks: {
            title: function (tooltipItem: any, data: any) {
              return data['labels'][tooltipItem[0]['index']];
            },
            label: function (tooltipItem: any, data: any) {
              const total = data['datasets'][0]['data'].reduce((accu: number, item: number) => accu + item, 0);
              const current = data['datasets'][0]['data'][tooltipItem['index']];
              const percent = (current / total) * 100;

              return `${Math.round(percent * 100) / 100}%`;
            }
          }
        }
      };

      (this as any).renderChart(chartData, Object.assign(this.skipDefaultTooltip ? {} : tooltipOptions, options));
    }
  }
</script>
